import { render } from "./ResetPasswordModal.vue?vue&type=template&id=42313c8f"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"
script.render = render

export default script